// extracted by mini-css-extract-plugin
export default {"container":"container--AoLyr","holder":"holder--ScP_U"};